<template>
    <div class="footer">
        <div class="top"><img src="@/assets/Icon-top.png" @click="toTop" alt=""></div>
        <div class="info">
            <div class="col-lg-4" :class="this.col6">
                <center>
                    <img alt="Interseguros" class="logo" src="@/assets/logo/Logo-interSeguros-h.webp" />
                    <div class="social-media">
                        <a href="https://www.instagram.com/intersegurosla/"><img src="@/assets/Instagram-footer.png" alt=""></a>
                        <a href="https://www.facebook.com/InterSegurosla"><img src="@/assets/Facebook-footer.png" alt=""></a>
                        <a href="https://twitter.com/InterSegurosla" target="_blank"><img style="filter: invert(19%) sepia(91%) saturate(1458%) hue-rotate(188deg) brightness(104%) contrast(109%); height: 25px;" src="@/assets/logo twitter.png" alt=""></a>
                        <a href="https://www.linkedin.com/company/intersegurosla/"><img src="@/assets/linkedin-footer.png" alt=""></a>
                    </div>
                </center>
            </div>
            <div class="col-lg-4" :class="this.col6">
                <center>
                    <h5>Nuestra comunidad</h5>
                    <a href="https://blog.grupogeos.co/" target="_blank" class="link">Blog</a>
                    <router-link aria-label="" class="link" to="/conocimiento">Base de conocimientos</router-link>
                </center>
            </div>
            <div class="col-lg-4" :class="this.col6">
                <center>
                    <h5>Ponte en contacto</h5>
                    <router-link aria-label="" class="link" to="/ventas">Contactar para ventas</router-link>
                    <img src="@/assets/Whatsapp-footer.png" class="footer-logo" alt=""><router-link aria-label="" class="link" to="/connect">+57 3004543623</router-link>
                    <img src="@/assets/Email-footer.png" class="footer-logo" alt=""><a aria-label="" class="link" href="mailto:ceo@grupogeos.co">informacion@grupogeos.co</a>
                    <img src="@/assets/icon-horario.svg" class="footer-logo" alt=""><a aria-label="" class="link">Lunes a viernes de 08:00 a.m. - 06:00 p.m y sábados de 08:00 a.m. - 12:00m.</a>
                    <img src="@/assets/icon-place.svg" class="footer-logo" alt=""><a aria-label="" class="link">Calle 124 #7c-44 oficina 501, Bogotá, Colombia</a>
                </center>
            </div>
        </div>
        <div class="copyright">
            <div class="col-lg-4" :class="this.col6"><center>Copyright © 2023 interseguros</center></div>
            <div class="col-lg-4" :class="this.col6"><center><a href="https://www.grupogeos.co/politica-privacidad" target="_blank" style="color: #fff">Politica de privacidad </a></center><center>Empresa del Grupo Empresarial OS <img src="@/assets/logo-geos.svg" class="geos-img" alt="GEOS"></center></div>
        </div>
        <a href="https://grupogeos.trb.ai/wa/161qkL2" class="whatsapp" target="_blank"> <font-awesome-icon icon="fa-brands fa-whatsapp" size="lg"/></a>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            col6: 'col-sm-6'
        }
    },
    methods: {
        myEventHandler() {
            if (window.innerWidth < 1000) {
                this.col6 = 'col-sm-4'
            }
        },
        toTop() {
            if (window.scrollY > 0) {
                var newScroll = window.scrollY - 10
                setTimeout(() => {
                    window.scrollTo(0, newScroll)
                    this.toTop()
                }, 1)
            }
        }
    },
    mounted() {
        if (window.innerWidth < 1000) {
            this.col6 = 'col-sm-4'
        }
    },
    created() {
        window.addEventListener('resize', this.myEventHandler)
    },
    destroyed() {
        window.removeEventListener('resize', this.myEventHandler)
    }
}
</script>

<style scoped>
.top {
    position: fixed;
    right: 25px;
    bottom: 100px;
    z-index: 999999;
}
.footer > .info{
    display: flex;
    background: #eef7fe;
    width: 100%;
}

.footer > .info > div > center {
    margin-top: 50px;
}

.footer > .info > div > center > .logo {
    width: 150px;
    margin-bottom: 50px;
}

.footer > .info > div > center > .social-media {
    margin-bottom: 50px;
}

.footer > .info > div > center > .social-media > a{
    position: relative;
    width: 60px;
    height: 60px;
}

.footer > .info > div > center > .social-media > a > img{
    transition: margin-top 0.5s ease-out 100ms;
}

.footer > .info > div > center > .social-media > a > img:hover {
    margin-top: -10px;
}

.footer > .info > div > center > h5 {
    font-family: 'JBD';
    color: #2d4f98;
    text-align: left;
}

.footer > .info > div > center > .link {
    text-align: left;
    display: block;
    font-family: 'JR';
    color: black;
}

.footer-logo {
    width: 20px;
    float: left;
    margin-right: 5px;
}

.copyright {
    font-size: 18px;
    font-family: 'JR';
    display: flex;
    background-color: #2d4f98;
    padding-top: 35px;
    padding-bottom: 35px;
    color: #fff;
    height: 150px;
}

.copyright > div > center > .geos-img {
    margin-top: -5px;
    margin-left: 5px;
    width: 40px;
}

.copyright > div > center > a > .ds2:hover {
   transition: margin-top 0.5s ease-out 100ms;
}

.copyright > div > center > a > .ds2:hover {
   margin-top: -5px;
}

.whatsapp {
    position:fixed;
    width:60px;
    height:60px;
    left:40px;
    right:40px;
    background-color:#25d366;
    color:#FFF;
    border-radius:50px;
    text-align:center;
    font-size:30px;
    z-index:100;
    bottom: 15px;
    padding: 8px;
}

.whatsapp-icon {
  margin-top:20px;
}

@media (max-width: 500px) {
    .copyright {
        display: block;
        font-size: 12px;
    }
    .footer > .info{
        display: block;
        text-align: center;
        padding-bottom: 25px;
    }
    .footer > .info > div > center > .logo {
        margin-bottom: 10px;
    }
    .footer > .info > div > center {
        margin-bottom: 50px;
        text-align: center;
        margin-top: 0px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue